export default "<p>usre-avatar works!</p>\r\n";